import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as contactApi from '../Api/contactApi';

const CONTACT_KEY = 'contacts';

export const useContact = (id, companyId) =>
	useQuery({
		queryKey: [CONTACT_KEY, id],
		queryFn: () => contactApi.getContactById(id, companyId),
		enabled: !!id && !!companyId,
	});

export const useCreateContact = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: contactApi.createContact,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CONTACT_KEY] });
			queryClient.invalidateQueries({ queryKey: ['lists'] });
		},
	});
};

export const useUpdateContact = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, contactData, companyId }) =>
			contactApi.updateContact(id, contactData, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CONTACT_KEY] });
		},
	});
};

export const useDeleteContact = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, companyId }) => contactApi.deleteContact(id, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CONTACT_KEY] });
		},
	});
};

export const useContactsByListId = (listId, companyId, options = {}) =>
	useQuery({
		queryKey: [CONTACT_KEY, 'list', listId, options],
		queryFn: () => contactApi.getContactsByListId(listId, companyId, options),
		enabled: !!listId && !!companyId,
	});

export const useAllContacts = (companyId, options = {}) =>
	useQuery({
		queryKey: [CONTACT_KEY, 'all', companyId, options],
		queryFn: () => contactApi.getAllContacts(companyId, options),
		enabled: !!companyId,
	});

export const useBulkImportContacts = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ contacts, listId, companyId }) =>
			contactApi.bulkImportContacts(contacts, listId, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CONTACT_KEY] });
		},
	});
};

export const useUpdateContactStatus = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, statusData, companyId }) =>
			contactApi.updateContactStatus(id, statusData, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CONTACT_KEY] });
		},
	});
};
